<script setup>
import { computed } from 'vue'
import formatDate from '@utils/format-date-full'
import MixOptions from '@components/mix/mix-options'
import GenrePills from '@components/genre/genre-pills'

const props = defineProps({
    mix: {
        type: Object,
        default: () => {},
    },
})

const airDate = computed(() => {
    if (props.mix.episode) {
        return formatDate(new Date(props.mix.episode.air_start))
    }
    return ''
})
</script>

<template>
    <div
        v-if="mix"
        class="mix-meta-tile"
    >
        <div class="mix-meta-tile-inner">
            <BaseResourceCover
                :image-resource="mix.episode"
                :media-resource="mix"
                media-type="mix"
                radius="card"
            >
                <template #secondaryActions>
                    <div>
                        <MixOptions :mix="mix" />
                    </div>
                </template>
            </BaseResourceCover>
            <h4 class="title">
                <BaseLink
                    v-if="mix && mix.artist"
                    :to="{ path: `/artist/${mix.artist.url}/${mix.artist.id}` }"
                >
                    <span class="title-inner">{{ mix.artist.title }}</span>
                </BaseLink>
                <BasePlaceholder
                    v-else
                    :size="13"
                />
            </h4>
            <h5 class="artist-title">
                <BaseLink
                    v-if="mix && mix.show"
                    :to="{ path: `/shows/${mix.show.id}` }"
                >
                    {{ mix.show.title }}
                </BaseLink>
                <BasePlaceholder
                    v-else
                    :size="11"
                />
            </h5>
            <p
                v-if="mix.description"
                class="description"
            >{{ mix.description }}</p>
            <div class="genres">
                <GenrePills
                    align="center"
                    :genres="mix.genre"
                />
            </div>
            <div class="button">
                <BaseButtonPlay
                    :icon="true"
                    class="button-inner"
                    :resource="mix"
                />
            </div>
            <div class="actions">
                <BaseFavourites
                    :mix="mix"
                    button-type="tag"
                />
            </div>
            <div class="release-date">
                <div v-if="mix && airDate">Released {{ airDate }}</div>
                <BasePlaceholder
                    v-else
                    :size="14"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.mix-meta-tile {
    text-align: center;

    &-inner {
        margin-bottom: $s-xl;

        @include widescreen {
            position: sticky;
            top: $s-xl + $s-xxxl;
            margin-bottom: 0;
        }
    }
}

.title {
    margin-top: $s-l;
    margin-bottom: 0;

    &-inner {
        color: $c-white;
    }
}

.artist-title {
    margin-top: 0;
    margin-bottom: $s-s;
    font-size: 20px;
    color: $c-text-faded;
}

.description {
    @extend %contentTinyHeading;

    margin-top: 0;
    margin-bottom: $s-l;
    text-align: center;
}

.actions {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: $s-l;
}

.release-date {
    @extend %contentTinyHeading;
}

.genres {
    margin-bottom: $s-l;
}
</style>
